import React, {useContext, useEffect} from "react";
import {useLocation, useNavigate} from "react-router";
import {CT} from "../../types/common_types";
import {Typography} from "@mui/material";
import {observer} from "mobx-react-lite";
import {AuthContext} from "../../stores/AuthStore";
import {AppRoutes} from "../../AppRoutes";

export const ProtectedRoute = observer((props: CT.Props.Children) => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!auth?.authenticated) {
      // remember where the user was headed so login can return them there
      navigate(AppRoutes.login, {
        replace: true,
        state: {from: location.pathname + location.search + location.hash},
      });
    }
  }, [navigate, auth?.authenticated, auth, location]);
  if (!auth?.authenticated) {
    return <Typography>Loading...</Typography>;
  }
  return props.children;
});